<template>
  <div class="member-modal-overlay" v-if="visible">
    <div class="member-modal">
      <div class="member-modal__body text-center">
        <h3 class="member-modal__title">
          You are not connected with this member. You may send a request to further communicate, collaborate and remain connected.
        </h3>
        <div class="member-modal__footer mt-4">
          <div class="btn-group">
            <button
              type="button"
              class="btn member-modal__btn member-modal__btn--confirm ml-0"
              @click="$emit('confirm')"
            >
              Connect
            </button>
            <button
              type="button"
              class="btn member-modal__btn member-modal__btn--cancel ml-3"
              @click="$emit('close')"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotConnectedModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.member-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 1000;
  display: flex;
  align-items: center;
}

.member-modal {
  width: 100%;

  &__body {
    background: #000;
    width: 480px;
    max-width: 90vw;
    margin: 0 auto;
    border-radius: 5px;
    padding: 20px 25px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    color: #ffffff;
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
  }

  &__title {
    font-size: 20px;
    letter-spacing: 0;
    margin-bottom: 0;
  }

  &__btn {
    font-size: 16px;
    padding: 10px 5px;
    min-width: 100px;
    line-height: 1;
    border-radius: 3px !important;
    border: none;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    &--confirm {
      background: rgba(33, 228, 0, 0.5);
      color: #fff;
      &:hover {
        background: #ffe738 !important;
        color: #22292f !important;
      }
    }

    &--cancel {
      background: rgba(255, 18, 18, 0.5);
      color: #fff;
      &:hover {
        background: #ffe738 !important;
        color: #22292f !important;
      }
    }
  }
}
</style>